jQuery(document).ready(function() {
    if(!is_dev) {
        return;
    }
    // view_device(4);
    // let check = 0;
    // check = setInterval(function() {
    //     if (jQuery('a#link-to-timeline').length > 0) {
    //         clearInterval(check);
    //         jQuery('a#link-to-timeline').click();
    //     }
    // },500);
});
function add_device(type, id, callback, onOpenCallback) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/inspections/devices/add/'+type+'/'+id,
        onOpen: function (elm, popup) {
            elm.find('#device_category_id').deviceCategorySelector().change(function() {
                show_the_right_device_meta_fields(elm, $(this));
            });

            load_device_product_selector(elm);

            if (onOpenCallback) {
                onOpenCallback(elm);
            }

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                popup.close();
                if (callback) {
                    callback(data);
                }
                reload_location_if_needed();
                if (!document.closeWindow) open_new_object(view_device, data);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function load_device_product_selector(elm) {
    const $ = jQuery.noConflict();

    elm.find('#name').keydown(function() {
        $(this).unbind('keydown');
        $(this).addClass('typed');
    });
    if (elm.find('#name').val().length > 0) {
        elm.find('#name').trigger('keydown');
    }
    const isNew = elm.find('[name="id"][value]').length === 0;
    elm.find('#product_id').productSelector().change(function() {
        look_for_product_and_do_the_following($(this).val(), function(product) {
            if (product && isNew) {
                elm.find('input[name="name"]:not(.typed)').val(product.name);

                if (Object.keys(product.deviceInfo).length > 0) {
                    const info = product.deviceInfo;
                    if (parseInt(info.device_category_id) > 0) {
                        elm.find('#device_category_id').val(info.device_category_id).trigger('change');

                        setTimeout(function() {
                            for(let key in info.metas) {
                                const input = elm.find('#metas-' + key + ':visible');

                                if (input.length > 0) {
                                    switch (input.attr('type')) {
                                        case 'checkbox':
                                        case 'radio':
                                            input[0].checked = parseInt(info.metas[key]) === 1;
                                        break;
                                        default:
                                            input.val(info.metas[key]);
                                        break;
                                    }
                                }
                            }
                        }, 250);
                    }
                }
            }
        });
    });
}

function view_device(id, vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/inspections/devices/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('[data-device-selector]').deviceSelector();
            elm.find('#device_category_id').deviceCategorySelector().change(function() {
                show_the_right_device_meta_fields(elm, $(this));
            });
            update_device_log_note_on_change(id, elm);

            // load_scheme_items_events(elm);
            load_device_product_selector(elm);
            // load_timeline_events(elm);

            elm.find('form').ajaxFormSubmit(function(data) {
                $('body').doneLoading();
                updateObject('device', id);
                if(vars && vars.reload_item) {
                    $(vars.reload_item).reloadThisElement();
                } else if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
                if (document.closeWindow) popup.close();
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function delete_device(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    custom_delete_with_confirmation("/inspections/devices/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'device');

    return false;
}

/**
 * Loads the screen for a new device category
 *
 * @param vars
 * @returns {boolean}
 */
function add_device_category(vars) {
    var $ = jQuery.noConflict();

    if(typeof vars == 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/inspections/categories/add',
        onOpen: function (elm, popup) {
            elm.find('#parent').deviceCategorySelector();

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                if(vars && vars.reload_item) {
                    $(vars.reload_item).reloadThisElement();
                } else if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
                reload_location_if_needed(true);
                if (!document.closeWindow) open_new_object(view_device_category, data);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function view_device_category(id, vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/inspections/categories/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('#parent').deviceCategorySelector();

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                updateObject('deviceCategory', id);
                if(vars && vars.reload_item) {
                    $(vars.reload_item).reloadThisElement();
                } else if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
                reload_location_if_needed(document.closeWindow)
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function delete_device_category(id, name) {

    var $ = jQuery.noConflict();

    custom_delete_with_confirmation("/inspections/categories/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'deviceCategory');

    return false;
}

function show_the_right_device_meta_fields(elm, select) {
    const $ = jQuery.noConflict();

    elm.find('.custom-fields-for-category').hide();
    elm.find('.custom-fields-for-category').find(':input').each(function() {
        if(!$(this).hasClass('checked')) {
            $(this).addClass($(this).is(':disabled') ? 'always-disabled' : 'not-always-disabled');
            $(this).addClass('checked');
        }
    });
    elm.find('.custom-fields-for-category').find(':input').attr('disabled','disabled');
    elm.find('.custom-fields-for-category--'+select.val()).show();
    elm.find('.custom-fields-for-category--'+select.val()).find(':input.not-always-disabled').removeAttr('disabled');
    elm.find('.show-if-visible-meta-fields').toggle(elm.find('.custom-fields-for-category:visible').length > 0);
}
function choose_devices_and_callback(client_id, filters, callback) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/inspections/devices/getChoiceList/' + client_id,
        data: {filters},
        onOpen: function (elm, popup) {
            elm.find('form').submit(function(e) {
                e.preventDefault();

                const data = $(this).serializeJSON();

                if (!data.device_ids || data.device_ids.length === 0) {
                    squde_flash('Selecteer minimaal één apparaat om verder te gaan', 'alert');
                } else {
                    popup.close();
                    if (callback) {
                        callback(data.device_ids);
                    } else {
                        console.log({device_ids: data.device_ids});
                    }
                }
            });
        }
    });
}


function get_device(id) {
    if(window.get_device_ajax) {
        window.get_device_ajax.abort();
    }
    window.get_device_ajax = jQuery.ajax({
        url: '/ajax/specialSelectorSearch?id=' + id + '&limit=1&type=device'
    });

    return window.get_device_ajax.then((answer) => {
        if (answer[0]) {
            return answer[0];
        }
        return null;
    });
}

function load_timeline_events(elm) {
    const $ = jQuery.noConflict();
    const indicator = elm.find('.drag-indicator');
    const timeline = elm.find('.device-timeline');

    let __recoupLeft = 0;

    const calibrationDaysInput = indicator.next();
    const actionUrl = timeline.parent().attr('data-action-url');
    const fullDays = parseInt(timeline.attr('data-days'));

    indicator.draggable({
        scroll: false,
        create: function (event, ui) {
            $(this).attr('oriLeft', $(this).css('left'));
        },
        start: function (event, ui) {
            $(this).css('cursor', 'pointer');
            let left = parseInt($(this).css('left'), 10);
            left = isNaN(left) ? 0 : left;
            __recoupLeft = left - ui.position.left;
        },
        drag: function (event, ui) {
            const max = $(this).prev().width() - 5;
            const __dx = ui.position.left - ui.originalPosition.left;

            ui.position.left = ui.originalPosition.left + (__dx);
            ui.position.left += __recoupLeft;
            ui.position.left = ui.position.left > max ? max : ui.position.left;
            ui.position.left = ui.position.left < 0 ? 0 : ui.position.left;

            ui.position.top = 0;

            // Determine 'closest' part on the timeline, mark that active
            const leftOffset = ui.helper.offset().left;
            let closestPart = timeline.find('.part:first');
            timeline.find('.part').each(function() {
                if (leftOffset > $(this).offset().left) {
                    closestPart = $(this);
                }
            });
            closestPart.addClass('active');
            timeline.children(':not(:nth-child(' + (closestPart.index() + 1) + '))').removeClass('active');

            // Calc it back to days
            let percentage = ui.position.left / max * 100;
            if (percentage < 0) {
                percentage = 0;
            }
            const days = Math.round(fullDays / 100 * percentage);
            calibrationDaysInput.val(days);

        },
        stop: function (event, ui) {
            $(this).css('cursor', 'default');
            const max = $(this).prev().width() - 5;

            calibrationDaysInput.trigger('change');
        }
    });

    calibrationDaysInput.change(() => {
        const data = {
            calibrationDays: calibrationDaysInput.val(),
        };

        // // TEST
        // const form = $('<form></form>');
        // form.attr('action', actionUrl);
        // form.attr('method', 'post');
        // form.attr('target', '_blank');
        // form.append('<input type="hidden" name="calibrationDays" value="' + calibrationDaysInput.val() + '" />');
        // form.submit(function() {
        //     setTimeout(() => $(this).remove(), 500);
        // });
        // $('body').append(form);
        // form.submit();
        // return;
        // // TEST

        $.post(actionUrl, data, (data) => {
            console.log({data});
        });
    });
}

function place_device_action_on_order(order_id, device_id) {
    const $ = jQuery.noConflict();
    $.post(`/administration/order/placeDeviceActionsOnOrder/${order_id}/${device_id}`, {}, () => {
        squde_reload_for_flashes();
    });
}

function set_device_consumable_install_date(device_id, product_id, sender) {
    const $ = jQuery.noConflict();
    const installDate = $(sender).val().trim();
    const originalValue = $(sender).attr('data-original-value');

    if (installDate.length > 0) {
        const parts = installDate.split('-')
            .filter((part, index) => {
                // day
                if (index === 0) {
                    return parseInt(part) <= 31;
                }
                // month
                if (index === 1) {
                    return parseInt(part) <= 12;
                }
                // year
                if (index === 2) {
                    return parseInt(part) >= 1900 && part <= 3000;
                }
                return false;
            });
        if (parts.length !== 3) {
            $(sender).val(originalValue);
            return;
        }
    }

    $.post(`/inspections/devices/setConsumableProductInstallDate/${device_id}/${product_id}`, {
        installDate
    }, () => {
        updateObject('deviceconsumable', product_id);
        $('.main-device-progress-wrapper').parents('.reveal').squdeReloadAjaxPopup();
    });
}


function update_device_log_note_on_change(deviceId, elm) {
    const $ = jQuery.noConflict();

    elm.find('.device-logs-table').bind('onReload', function() {
        const table = $(this);
        table.find('input[name="notes"]').keyup(function () {
            const input = $(this);
            if (input[0].timeout) {
                clearTimeout(input[0].timeout);
            }
            const notes = input.val();
            const log = input.parents('tr').attr('data-id');
            input[0].timeout = setTimeout(() => {
                $.post(`/inspections/devices/${deviceId}/updateLogNotes/${log}`, { notes });
            }, 1000);
        });
    });
}

function replace_device_consumable(deviceId, productId, replacesDeviceId = null) {
    const $ = jQuery.noConflict();

    const replacesDevice = !_.isNil(replacesDeviceId);

    $.squdeAjaxPopup({
        url: `/inspections/devices/getReplaceConsumableOrDeviceView/${deviceId}/${productId}`,
        data: {
            replaces_device_id: replacesDeviceId,
        },
        size: 'tiny',
        onOpen: function(elm, popup) {
            const replaceDateInput = elm.find('#replace_date');
            replaceDateInput.bind('keyup change', function() {
                let isValid;
                const [day, month, year] = $(this).val().split('-').map(p => parseInt(p, 10));

                // Check the ranges of month and year
                if(year < 1000 || year > 3000 || month === 0 || month > 12) {
                    isValid = false
                } else {
                    const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

                    // Adjust for leap years
                    if(year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                        monthLength[1] = 29;
                    }

                    // Check the range of the day
                    isValid = day > 0 && day <= monthLength[month - 1];
                }

                if (isValid) {
                    elm.find('[type="submit"]').removeAttr('disabled');
                } else {
                    elm.find('[type="submit"]').attr('disabled', 'disabled');
                }
            });



            elm.find('form').submit(function(e) {
                e.preventDefault();

                const data = $(this).serializeJSON();
                if (data.add_product_to === 'nothing') {
                    _.unset(data, 'order_id');
                    _.unset(data, 'was_delivered');
                    _.unset(data, 'invoice_id');
                } else if (data.add_product_to === 'order') {
                    _.unset(data, 'invoice_id');
                    data.order_id = parseInt(data.order_id, 10);
                    data.was_delivered = data.was_delivered === '1';
                } else if (data.add_product_to === 'invoice') {
                    _.unset(data, 'order_id');
                    _.unset(data, 'was_delivered');
                    data.invoice_id = parseInt(data.invoice_id, 10);
                }
                data.owner = parseInt(data.owner, 10);

                const consumableCallback = (newProductId) => {
                    popup.close();
                    if (data.add_product_to === 'nothing') return;
                    let url;
                    if (data.add_product_to === 'order') {
                        url = `/inspections/devices/addConsumableToOrder/${newProductId}`;
                    }
                    if (data.add_product_to === 'invoice') {
                        url = `/inspections/devices/addConsumableToInvoice/${newProductId}`;
                    }

                    $.post(url, data, function() {
                        squde_reload_for_flashes(() => {
                            reload_location_if_needed(true);
                        });
                    });
                }

                if (replacesDevice) {
                    add_device(data.ownerType, data.owner, (device) => consumableCallback(device.product_id), (elm) => {
                        elm.find('.replaces-device-wrapper').show();
                        elm.find('input[name="buy_date"]').val(data.replace_date);
                        elm.find('input[name="replace_date"]').val(data.replace_date);
                        elm.find('input[name="replace_date"]').removeAttr('disabled');
                        elm.find('input[name="replaces_device_id"]').val(replacesDeviceId);
                        elm.find('input[name="replaces_device_id"]').removeAttr('disabled');
                    })
                } else {
                    $.post(`/inspections/devices/setConsumableProductInstallDate/${deviceId}/${productId}`, {
                        installDate: data.replace_date,
                    }, () => {
                        updateObject('deviceconsumable', productId);
                        consumableCallback(productId);
                    });
                }

                return false;
            })
        }
    });
    return false;
}
